<button mat-icon-button type="button" (click)="toggleVisibility()" tabindex="-1">
  <mat-icon>{{ passwordViewer.visible ? 'visibility_off' : 'visibility' }}</mat-icon>
</button>
